import { ErrorFlag } from "../../components/error-flag/ErrorFlag";
import { Flex } from "../../components/flex/Flex.Parts";
import { text } from "./Route404.Parts";

export const Route404Page = () => (
  <Flex $flow="column" $align="center" $fullHeight>
    <ErrorFlag header={text.header} message={text.message} />
  </Flex>
);
